/**
 * @generated SignedSource<<e2ce94dbae70b76cb473ed04e77b2523>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksContentHeadlineTagContent$data = {
  readonly flag: string | null | undefined;
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly types?: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly description: {
        readonly text: string | null | undefined;
      } | null | undefined;
      readonly entityId: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsStyleArticle" | "hooksContentHelperContent">;
  readonly " $fragmentType": "hooksContentHeadlineTagContent";
};
export type hooksContentHeadlineTagContent$key = {
  readonly " $data"?: hooksContentHeadlineTagContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksContentHeadlineTagContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksContentHeadlineTagContent"
};

(node as any).hash = "faed5c4d9570212786f99b1c185f55da";

export default node;
